export default __webpack_public_path__ + "static/media/steps__slider-main-item-icon-little-1.4ed43f9a.svg";